module.exports = __webpack_public_path__ + "static/dea_logo-1eaa1c724be31f1eed8838e0d786f155.svg";